import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const menuDefaultVariants = {
  "descriptionPosition": "bottom"
}
const menuCompoundVariants = [
  {
    "hasDescription": true,
    "descriptionPosition": "bottom",
    "css": {
      "item": {
        "alignItems": "flex-start"
      },
      "itemIcon": {
        "alignSelf": "flex-start"
      },
      "itemIndicator": {
        "alignSelf": "flex-start"
      }
    }
  }
]

const menuSlotNames = [
  [
    "root",
    "menu__root"
  ],
  [
    "content",
    "menu__content"
  ],
  [
    "searchContainer",
    "menu__searchContainer"
  ],
  [
    "search",
    "menu__search"
  ],
  [
    "searchInput",
    "menu__searchInput"
  ],
  [
    "searchClear",
    "menu__searchClear"
  ],
  [
    "itemContainer",
    "menu__itemContainer"
  ],
  [
    "item",
    "menu__item"
  ],
  [
    "itemText",
    "menu__itemText"
  ],
  [
    "itemLabel",
    "menu__itemLabel"
  ],
  [
    "itemIndicator",
    "menu__itemIndicator"
  ],
  [
    "itemIcon",
    "menu__itemIcon"
  ],
  [
    "itemDescription",
    "menu__itemDescription"
  ],
  [
    "itemCaption",
    "menu__itemCaption"
  ],
  [
    "itemCaptionDivider",
    "menu__itemCaptionDivider"
  ],
  [
    "groupLabel",
    "menu__groupLabel"
  ],
  [
    "group",
    "menu__group"
  ],
  [
    "separator",
    "menu__separator"
  ],
  [
    "emptyState",
    "menu__emptyState"
  ]
]
const menuSlotFns = /* @__PURE__ */ menuSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, menuDefaultVariants, getSlotCompoundVariant(menuCompoundVariants, slotName))])

const menuFn = memo((props = {}) => {
  return Object.fromEntries(menuSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const menuVariantKeys = [
  "selected",
  "active",
  "descriptionPosition",
  "hasCaption",
  "hasDescription"
]
const getVariantProps = (variants) => ({ ...menuDefaultVariants, ...compact(variants) })

export const menu = /* @__PURE__ */ Object.assign(menuFn, {
  __recipe__: false,
  __name__: 'menu',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: menuVariantKeys,
  variantMap: {
  "selected": [
    "true"
  ],
  "active": [
    "true"
  ],
  "descriptionPosition": [
    "bottom",
    "right"
  ],
  "hasCaption": [
    "true"
  ],
  "hasDescription": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, menuVariantKeys)
  },
  getVariantProps
})